<div class="main-content">
<div class="container-fluid">
	<div class="row">
		<div class="col-md-12">
			<div class="card tp-box">
				<div class="card-header card-header-{{config.color}}-5">
					<div class="row">
						<div class="col-10">
							<h4 class="card-title ">
								<i class="material-icons" (click)="back()">arrow_left</i> Credit Entry
								<span *ngIf="customer_data">
									{{ customer_data.debtorno }}.{{ customer_data.branchcode }} {{ customer_data.name }}
								</span>
							</h4>
						</div>
					</div>
				</div>
				<div class="card-body">
					<app-customer-lookup (customer_selected)="selectCustomer($event)"></app-customer-lookup>
					<ng-container *ngIf="customer_data">
					<mat-tab-group #tabPanel mat-align-tabs="start" class="no-overflow" color="accent" [(selectedIndex)]="selectedindex" >

						<mat-tab label="Credit">
							<ng-template matTabContent>
							<app-shared-credit-entry (reloadCustomer)="updateCustomer($event)" [customer]="customer_data" [flip]="'inactive'" [type]="'11'"></app-shared-credit-entry>
							</ng-template>
						</mat-tab>

						<mat-tab label="Credit an Invoice">
							<ng-template matTabContent>
								<app-credit-customer-orders [(customerdata)]="customer_data" (cart_updated)="reloadOrder($event)"> </app-credit-customer-orders>
							</ng-template>
						</mat-tab>
					</mat-tab-group>
					</ng-container>
				</div>
			</div>
		</div>
	</div>
</div>
</div>
